import React, { useEffect } from 'react';
import AIs from '../Home/AIs/AIs';
import MetaData from '../../Components/MetaData/MetaData';

const DoItYourself = () => {
  useEffect(() => {
    window.scroll(0,0);
  } ,[])
  return (
    <div>
      <MetaData
        pageTitle="AI Tools - Do It Yourself | WhalesAI"
        pageDescription="Explore all WhalesAI tools. Generate images, videos, text, business plans and more with AI."
      />
      <AIs />
    </div>
  );
};

export default DoItYourself;
